// Putting logout because of no activity
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toastMessage } from "../utils/toastMessage";

// this code is created an instance with base url for admin
// const url =
export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export const getToken = () => localStorage.getItem("token") || null;
export const setJwtToken = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

export const setMultiPartHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
};

// this interceptors checks user's token is valid or not
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  const removeToken = () => {
    localStorage.removeItem("token");
  };

  useEffect(() => {
    const resInterceptor = (response) => {
      if (response?.data?.status === 401) {
        removeToken();
        navigate("/");
      }
      return response;
    };

    const errInterceptor = (error) => {
      if (error?.code === "ERR_NETWORK") {
        toastMessage(error?.message, "error", "networkError");
      }
      if (error?.response?.data?.status === 422) {
        toastMessage(error?.response?.data?.message, "error", "422");
      }
      if (error?.response?.data?.code === 404) {
        toastMessage(
          error?.response?.data?.message || "Bad request",
          "error",
          "Not Found On Server"
        );
        navigate("/");
        return error;
      }
      if (error.response && error.response?.data?.code === 400) {
        toastMessage(error.response?.data?.message, "error", "errorMeesage");
      }
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);

  return isSet && children;
};

const LOGOUT_TIME = 1000 * 60 * 5; // 5 min.
const events = ["mousemove", "mousedown", "keydown", "scroll"]; // adding events for inactivity

export const AppLogout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const logoutTimer = useRef(null);

  const lastInteractionTime = useRef(
    parseInt(localStorage.getItem("lastInteractionTime")) || Date.now()
  );

  const handleLogout = () => {
    toastMessage("Session Expired. Please login again.", "error", "Inactivity");
    localStorage.clear();
    navigate("/");
  };

  const resetTimer = () => {
    clearTimeout(logoutTimer.current);
    logoutTimer.current = setTimeout(logoutIfInactive, LOGOUT_TIME);
  };

  const logoutIfInactive = () => {
    const currentTime = Date.now();
    if (currentTime - lastInteractionTime.current >= LOGOUT_TIME) {
      handleLogout();
    } else {
      resetTimer();
    }
  };

  const recordInteraction = () => {
    lastInteractionTime.current = Date.now();
    localStorage.setItem("lastInteractionTime", lastInteractionTime.current);
  };

  const onFocus = () => {
    recordInteraction();
    resetTimer();
  };

  const onVisibilityChange = () => {
    if (!document.hidden) {
      const timeSinceLastInteraction = Date.now() - lastInteractionTime.current;
      if (timeSinceLastInteraction >= LOGOUT_TIME) {
        handleLogout();
      } else {
        resetTimer();
      }
    } else {
      clearTimeout(logoutTimer.current);
    }
  };

  const addEventListeners = () => {
    events.forEach((event) => {
      window.addEventListener(event, recordInteraction);
    });
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibilityChange);
  };

  const removeEventListeners = () => {
    events.forEach((event) => {
      window.removeEventListener(event, recordInteraction);
    });
    window.removeEventListener("focus", onFocus);
    document.removeEventListener("visibilitychange", onVisibilityChange);
  };

  // useEffect(() => {
  //   if (location.pathname !== "/") {
  //     addEventListeners();
  //     resetTimer();
  //   }

  //   return () => {
  //     removeEventListeners();
  //     clearTimeout(logoutTimer.current);
  //   };
  // }, [location.pathname]);

  return children;
};
